import ChevronRight from '../src/ChevronRight/index.tsx';
export default ChevronRight;
